import { getLocaleCurrencyCode, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AdHocProductModule } from './ad-hoc-product/ad-hoc-product.module';
import { AdminLoginComponent } from './admin-login.component';
import { AppConfigErrorPage } from './app-config/app-config-error.page';
import { AppConfigService, DEFAULT_LOCALE } from './app-config/app-config.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppInitializer } from './app.initializer';
import { AuthTokenInterceptor } from './auth/auth-token.interceptor';
import { CashBoxUuidInterceptor } from './data/cash-box-uuid.interceptor';
import { CoreModule } from './core/core.module';
import { AppErrorHandler } from './core/error-handling/error-handler';
import { NetworkErrorPage } from './core/network-error.page';
import { CustomersModule } from './customer/customers.module';
import { APP_SETTINGS_PROVIDER } from './data/settings-data.provider';
import { DepositWithdrawModule } from './deposit-withdraw/deposit-withdraw.module';
import { ReservationModule } from './reservation/reservation.module';
import { TransactionHistoryModule } from './transaction-history/transaction-history.module';

// TODO: register other locales to support other currency formatting
import localeDe from '@angular/common/locales/de';
registerLocaleData(localeDe);

@NgModule({ declarations: [
        AppComponent,
        AppConfigErrorPage,
        NetworkErrorPage,
        AdminLoginComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NgbModule,
        CoreModule,
        TransactionHistoryModule,
        CustomersModule,
        AdHocProductModule,
        DepositWithdrawModule,
        ReservationModule], providers: [
        // Error handling
        { provide: ErrorHandler, useClass: AppErrorHandler },
        // Load app configuration at startup
        AppInitializer,
        APP_SETTINGS_PROVIDER,
        // Http
        { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: CashBoxUuidInterceptor, multi: true },
        { provide: LOCALE_ID, deps: [AppConfigService], useFactory: (configService: AppConfigService) => configService.getConfig()?.locale ?? DEFAULT_LOCALE },
        { provide: DEFAULT_CURRENCY_CODE, deps: [LOCALE_ID], useFactory: (locale: string) => getLocaleCurrencyCode(locale) },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
